import {Component, Input} from '@angular/core';
import {Subheadline} from '@spirit-testing/component-library';
import {MatDivider, MatList} from '@angular/material/list';

@Component({
  selector: 'app-analyze-result',
  imports: [
    Subheadline,
    MatList,
    MatDivider
  ],
  templateUrl: './analyze-result.component.html',
  styleUrl: './analyze-result.component.scss'
})
export class AnalyzeResultComponent {
  @Input() strengths: string[] = [];
  @Input() weaknesses: string[] = [];
  @Input() gaps: string[] = [];
  @Input() matches: string[] = [];
  @Input() recommendations: string[] = [];
  @Input() summary: string = '';
}
